module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Accueil":"Home","Nous joindre":"How to reach us"}}')
  delete Component.options._Ctor
}
